import { AsyncRoute } from "@/models/async-route"
import store from "@/store"
import { Message } from "element-ui"
import { PaasTenant } from "@/models/paas-tenant"
import router from "./index"
import { Device } from "@/lib/device"


/**
 * 进入路由前的逻辑
 */
router.beforeEach((to, from, next) => {
  // set meta
  store.commit('SET_META', to.meta)

  if (to.path === '/overdue' || to.path === "/site-not-page") {
    next()
  } else {
    PaasTenant.getTenantInfo().then(async res => {
      if(!res){
        next("/site-not-page")
        return
      }
      if(!res.isAvailable){
        next("/overdue")
        return
      }
      if (AsyncRoute.isExist()) {
        next()
      } else {
        try {
          if(Device.isMobile()){
            await store.dispatch('GET_BASE_INFO_M')
          }else{
            await store.dispatch('GET_BASE_INFO')
          }
          store.dispatch('GET_LOGIN_INFO')
          const asyncRoutes = await AsyncRoute.getAsyncRoute()
          router.addRoutes(asyncRoutes)
          next({ ...to, replace: true })
        } catch (error) {
          Message.error('路由获取失败，请检查网络。')
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/before.js